class ScrollingListController {

  constructor($scope,laboxRemote) {
    this.name = 'scrollingList';
    $scope.$watch('vm.items', () => {
      this.position = 0;
      this.rotationItems = [];
      this.generateRotationMenu();
    });

    //----------------//
    //-----Events-----//
    //----------------//

    this.onKeyDown=(e)=> {
      switch (true) {
        case laboxRemote.isLeft(e): // ARROW_LEFT
          this.navigateLeft(event);
          this.generateRotationMenu();
          break;
        case laboxRemote.isRight(e): // ARROW_RIGHT
          this.navigateRight(event);
          this.generateRotationMenu();
          break;
        case laboxRemote.isEnter(e): // ENTER/OK
          this.selectCurrent();
          break;
      }
    };
  }

  generateRotationMenu() {
    if (!this.items) {
      this.items = [];
      this.rotationItems = [];
      return;
    }
    const count = this.items.length;
    const pos = this.position;
    const previousPos = (count + (pos - 1)) % count;
    const nextPos = (pos + 1) % count;
    this.rotationItems = [
      this.items[previousPos],
      this.items[pos],
      this.items[nextPos]
    ];
  }

  navigateLeft(event) {
    const count = this.items.length;
    this.position = (count + (this.position - 1)) % count;
    event.preventDefault();
  }

  navigateRight(event) {
    const count = this.items.length;
    this.position = (this.position + 1) % count;
    event.preventDefault();
  }

  getCurrentItem() {
    return this.items[this.position];
  }

  selectCurrent() {
    this.onSelect({
      item: this.getCurrentItem()
    });
  }

}

ScrollingListController.$inject = ['$scope','laboxRemote'];

export default ScrollingListController;



// WEBPACK FOOTER //
// ./client/app/components/scrollingList/scrollingList.controller.js